// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"e7ef0341","83":"4a450ba4","421":"74967898","422":"3835472b","588":"8e36f2bd","675":"ce567f93","679":"4722820c","711":"3524c6ab","726":"bddca1fe","791":"b74afaec","926":"16194dc8"}[chunkId] + ".chunk.js";
};